import { errors } from 'rfc9457';

import { readEnvVariable } from '../helpers';

export interface ISlackEnv {
  botToken: string;
}

export function getSlackEnv(): ISlackEnv {
  const botToken = readEnvVariable('SLACK_BOT_TOKEN');

  if (!botToken) {
    throw errors.server.envNotSet('SLACK_BOT_TOKEN');
  }

  return { botToken };
}
